var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapperNode,{tag:"component",class:[`${_vm.$appPrefix}-repeater`]},[_vm._l((_vm.n),function(index){return _vm._t("default",null,{"index":index - 1,"total":_vm.n})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }